import { render, staticRenderFns } from "./method.vue?vue&type=template&id=d63f72de&scoped=true"
import script from "./method.vue?vue&type=script&lang=js"
export * from "./method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63f72de",
  null
  
)

export default component.exports